import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApplicationApi } from '@classes/application/application';
import { ApplicationList, ClientAdd } from '@classes/client/addClient';
import { ClientSmartHub } from '@classes/client/client';
import { RoleApi } from '@classes/role/role';
import { AddUser } from '@classes/user/userAdd';
import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from '@services/application/application.service';
import { ClientService } from '@services/client/client.service';
import { RolesService } from '@services/roles/roles.service';
import { UiService } from '@services/ui/ui.service';
import { DialogData } from 'app/components/smartparking/smartparking-slots-add/smartparking-slots-add.component';


@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.scss']
})
export class AddClientComponent implements OnInit {
  faPlus = faPlus;
  faTrashAlt = faTrashAlt;

  addClientForm: UntypedFormGroup;
  inactive = true;
  ArrayValueInput: string[] = [];
  confirmAdd = false;
  clients: ClientSmartHub[];
  roles: RoleApi[];
  appChoice: string[] = [];
  applicationsFiltered: ApplicationApi[];
  client: ClientSmartHub;
  applicationList: ApplicationApi[];
  applications: ApplicationApi[];

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,

    private clientService: ClientService,
    private applicationService: ApplicationService,
    private roleService: RolesService,
    private uiService: UiService,
    public dialogRef: MatDialogRef<AddClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.getAllClients();
    this.getAllApplications();
    this.initForm();

  }


  onSubmit(): void {

    const app: ApplicationList[] = this.f.applicationList.value.map(a => a.applicationName)
    const newClient = new ClientAdd(this.f.name.value, app, true);




    this.clientService.addClient(newClient).subscribe({
      next: () => this.dialog.closeAll()

    })
  }

  isInactive(): void {

  }

  addApplicationInput(): void {
    this.applicationControls.controls?.length < this.applications?.length ?
      this.applicationControls.push(this.createApplicationInput()) :
      this.uiService.showSnackbar('Vous ne pouvez plus ajouter d\'application');
  }

  deleteApplicationInput(index: number): void {
    this.applicationControls.removeAt(index);
  }

  filterValuesApp(index: number, app?: string): boolean {
    const appPrevious = [];

    for (let i = index; i > 0; i--) {
      const appName = this.getApplicationControlsInput(i - 1).value;
      appPrevious.push(appName);
    }

    return appPrevious.includes(app) ? false : true;
  }


  get f() {
    return this.addClientForm.controls;

  }

  get applicationControls(): UntypedFormArray {
    return this.addClientForm.controls.applicationList as UntypedFormArray;
  }
  getApplicationControlsInput(index: number): UntypedFormGroup {
    return this.applicationControls.controls[index]['controls'].applicationName as UntypedFormGroup;
  }

  private getAllClients(): void {
    this.clientService.getAllClients().subscribe({
      next: clients => this.clients = clients
    });
  }
  private getAllApplications(): void {
    this.applicationService.getAllApplications().subscribe({
      next: applications => {
        this.applications = applications;
        this.applicationsFiltered = applications;

      }
    });
  }



  private initForm(): void {
    this.addClientForm = this.formBuilder.group({

      name: [this.client?.name, [Validators.required]],
      applicationList: this.formBuilder.array([])

    });

    // this.addClientForm.get('client').setValue(this.data.client.name);

  }

  private createApplicationInput(): UntypedFormGroup {
    return this.formBuilder.group((({
      applicationName: ['', Validators.required],

    })));
  }



}

